import { Component, Inject, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { MatDialog, MatDialogRef, MatDialogConfig, MAT_DIALOG_DATA, MatSnackBar } from '@angular/material';
import { DOCUMENT } from '@angular/platform-browser';

import { PortService } from '../../_services/port.service';
import { EmitterService } from '../../_services/emitter.service';

@Component({
    selector: 'app-add-port',
    template: ''
})
export class AddPortComponent {

    dialogRef: MatDialogRef<AddPortDialogComponent>;

    config: MatDialogConfig = {
        disableClose: false,
        hasBackdrop: true,
        backdropClass: '',
        width: '500px',
        height: '',
        position: {
            top: '',
            bottom: '',
            left: '',
            right: ''
        },
        data: {}
    };


    constructor(public dialog: MatDialog, @Inject(DOCUMENT) private doc: any,
        private router: Router,
        private activatedRoute: ActivatedRoute) {

        dialog.afterOpen.subscribe(() => {
            if (!doc.body.classList.contains('no-scroll')) {
                doc.body.classList.add('no-scroll');
            }
        });

        this.config.data.pmoId = activatedRoute.snapshot.params['pmoId'];
        this.openModal();
    }

    openModal() {
        this.dialogRef = this.dialog.open(AddPortDialogComponent, this.config);

        this.dialogRef.afterClosed().subscribe((result: string) => {
            this.dialogRef = null;
            this.router.navigate(['../']);
            this.doc.body.classList.remove('no-scroll');

            EmitterService.get('AddPortDialogComponent').emit(result);
        });
    }

}

@Component({
    selector: 'app-add-port-dialog',
    templateUrl: './add-port.component.html',
    styleUrls: ['./add-port.component.less']
})
export class AddPortDialogComponent implements OnInit {

    private busy: boolean;
    private pmoId: number;
    private title: string;

    constructor(private dialogRef: MatDialogRef<AddPortDialogComponent>,
        @Inject(MAT_DIALOG_DATA) private data: any,
        private portService: PortService,
        private snackBar: MatSnackBar) {

        this.pmoId = this.data.pmoId;
    }

    ngOnInit() {
        this.busy = false;
    }

    add(form) {
        this.busy = true;
        this.dialogRef.disableClose = true;

        this.portService.addPort(this.pmoId, this.title)
            .subscribe(
                response => {
                    let result = response.json().Result;
                    this.dialogRef.close(result.Id);

                    this.snackBar.open('Port was added successfully.', null, { duration: 2000 });
                },
                error => {
                    this.busy = false;
                    this.dialogRef.disableClose = false;

                    this.snackBar.open(error.Message, null, { duration: 3000 });
                });
    }
}



// WEBPACK FOOTER //
// ./Angular/app/home/add-port/add-port.component.ts